module.exports = __webpack_public_path__ + "img/bg-login.a2d7d628.png";